export const UPDATE_PLATFORM = "UPDATE_STAKING_PLATFORM";
export const GET_SELECTED_PLATFORM = "GET_SELECTED_PLATFORM";
export const GET_SELECTED_PAYOUT = "GET_SELECTED_PAYOUT";
export const GET_SELECTED_PLAN = "GET_SELECTED_PLAN";
export const CREATE_PLATFORM='CREATE_PLATFORM';
export const FETCH_TIME_UNIT='FETCH_TIME_UNIT'
